:host {
  display: block;
  position: relative;
  background-color: rgb(255 255 255 / 60%);
  text-align: center;
  padding: $sd-spacing-10 $sd-spacing-6 $sd-spacing-8;

  @include breakpoint($desktop) {
    padding-left: $sd-spacing-10;
    padding-right: $sd-spacing-10;
  }

  .icon-container {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    background-color: $sd-backgroundColor-white;
    height: 3.75rem;
    width: 3.75rem;
    margin-left: auto;
    margin-right: auto;
    left: 0;
    right: 0;
    top: -1.875rem;
    border-radius: 50%;
    animation: 0.5s scale cubic-bezier(0.4, 0.03, 0.4, 0.97);
    animation-delay: var(--icon-scale-delay, 0);

    sd-icon {
      fill: $sd-backgroundColor-white;
      width: 1.875rem;
      height: 1.875rem;
    }
  }

  @keyframes scale {
    0% {
      transform: scale(1);
    }

    50% {
      transform: scale(1.2);
    }

    100% {
      transform: scale(1);
    }
  }
}

:host([big]) {
  padding-top: $sd-spacing-12;
  min-width: 40%;

  .icon-container {
    height: 5rem;
    width: 5rem;
    top: -2.5rem;

    sd-icon {
      width: 3.125rem;
      height: 3.125rem;
    }
  }
}
